export default [
  {
    url: "/calendar",
    name: "Calendar",
    icon: "account_box",
  },
  {
    url: "/chats",
    name: "Chats",
    icon: "chat",
  },
  {
    url: "/category",
    name: "Daily Status",
    icon: "assignment",
  },
  {
    url: "/musicCategory",
    name: "Music",
    icon: "assignment",
  },
  {
    url: "/horoscopePage",
    name: "Horoscope",
    icon: "assignment",
  },
  {
    name: "Articles",
    icon: "assignment",
    submenu: [
      {
        url: "/articlecategory",
        name: "Article Category",
      },
      {
        url: "/articles/recent",
        name: "Recent Articles",
      },
    ],
  },
  {
    url: "/festival",
    name: "Festivals",
    icon: "assignment",
  },
  {
    url: "/notificationSrv",
    name: "Notifications",
    icon: "dynamic_feed",
  },
  {
    url: "/users",
    name: "Users",
    icon: "account_box",
  },
  {
    name: "Settings",
    icon: "account_box",
    submenu: [
      {
        url: "/edit-profile",
        name: "Manage Profile",
      },
      {
        url: '/tag',
        name: "Tag Settings",
      },
      {
        url: "/language",
        name: "Language",
      },
      {
        url: "/apps",
        name: "Apps",
      },
      {
        url: "/accounts",
        name: "Admin Accounts",
      },
      {
        url: "/settings",
        name: "Global Settings",
      },
    ],
  },
  {
    name: "Events",
    icon: "assignment",
    submenu: [
      {
        url: "/eventcategory",
        name: "Event Category",
      },
      {
        url: "/events",
        name: "Recent Events",
      },
      {
        url: "/notification",
        name: "Event Notification",
      },
    ],
  },
  {
    name: "More Options",
    icon: "dynamic_feed",
    submenu: [
      {
        url: "/banners",
        name: "Banner",
      },
      {
        url: "/contest",
        name: "Contest",
      },
      {
        url: "/offer",
        name: "Offer",
      },
      {
        url: "/payments",
        name: "Payments",
      },
      {
        url: "/consult-astrology",
        name: "Consult Astrology",
      },
      {
        url: "/bhakti-promotion",
        name: "Bhakti Promotion",
      },
    ],
  },
];
